import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import { ItemListItem } from '../ItemList';
import Menu from '../Menu';
export var ITEM_DISPLAY_NAME = 'Dropdown.Item';

var Item = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Item, _Component);

  function Item() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Item.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        index = _this$props.index,
        onSelect = _this$props.onSelect,
        text = _this$props.text,
        value = _this$props.value,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["disabled", "index", "onSelect", "text", "value"]);

    return /*#__PURE__*/React.createElement(ItemListItem, {
      data: value,
      text: text,
      disabled: disabled,
      index: index,
      onSelect: onSelect
    }, function (_ref) {
      var id = _ref.id,
          highlight = _ref.highlight,
          highlighted = _ref.highlighted,
          clearHighlight = _ref.clearHighlight,
          select = _ref.select;
      return /*#__PURE__*/React.createElement(Menu.Item, _extends({
        id: id,
        role: "menuitem",
        "aria-disabled": disabled,
        disabled: disabled,
        isHighlighted: highlighted,
        onMouseOver: highlight,
        onMouseOut: clearHighlight,
        onClick: select
      }, restProps));
    });
  };

  return Item;
}(Component);

_defineProperty(Item, "displayName", ITEM_DISPLAY_NAME);

export default Item;